import { Zap, Cloud, Truck, CheckCircle2 } from "lucide-react";
import LegalLayout, { COMPANY } from "./LegalLayout";

export default function HizmetTeslimati() {
  return (
    <LegalLayout eyebrow="Yasal Belge" title="Hizmet Teslimatı" updated="8 Şubat 2026">
      {/* Legal opening — highlighted callout box for compliance clarity */}
      <div className="not-prose border-2 p-5 sm:p-6 mb-8" style={{ borderColor: "var(--gold)", background: "linear-gradient(135deg, rgba(212,175,55,0.10), rgba(212,175,55,0.02))" }}>
        <div className="label-caps mb-2" style={{ color: "var(--gold)" }}>YASAL BEYAN</div>
        <p className="text-white text-base sm:text-lg leading-relaxed font-medium m-0">
          {COMPANY.brand} <strong>bir dijital yazılım hizmetidir</strong>, <strong>fiziksel kargo gönderimi yapılmaz</strong>, aktivasyon <strong>ödeme sonrası anlık gerçekleşir</strong>.
        </p>
      </div>
      <p>Bu politika, {COMPANY.brand}'in ({COMPANY.legalName}) sunduğu SaaS hizmetinin nasıl teslim edildiğine dair 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği kapsamındaki resmi beyanıdır.</p>

      <h2>1. Hizmetin Niteliği</h2>
      <p>{COMPANY.brand}, bulut altyapısı üzerinde çalışan bir Yazılım Hizmeti (SaaS)'tir. Kullanıcılar hizmete internet tarayıcısı veya mobil cihazlarına yükleyebilecekleri PWA (Progressive Web App) üzerinden erişir. Ortada satılan hiçbir fiziksel ürün yoktur; bu nedenle geleneksel "kargo/teslimat" süreci uygulanmaz.</p>

      <h2>2. Aktivasyon Süreci</h2>
      <ul>
        <li><strong>Adım 1:</strong> Kullanıcı hesabını oluşturur ve e-posta adresini doğrular.</li>
        <li><strong>Adım 2:</strong> Aboneliği PayTR güvenli ödeme sayfasından onaylar (3D Secure destekli).</li>
        <li><strong>Adım 3:</strong> Ödeme başarıyla tamamlandığı anda hesaba tüm modüller <strong>otomatik olarak</strong> ve <strong>anında</strong> aktive edilir.</li>
        <li><strong>Adım 4:</strong> Faturayı ve aktivasyon onayını e-posta ile alırsınız.</li>
      </ul>
      <p>Aktivasyon süresi normal koşullarda <strong>5 saniyeden azdır</strong>. Nadir teknik gecikmelerde en geç birkaç dakika içinde tamamlanır.</p>

      <h2>3. Fiziksel Kargo Yapılmaz</h2>
      <p>{COMPANY.brand} hizmetinin niteliği gereği herhangi bir fiziksel ürün, CD, USB, kutu veya kart Alıcı adresine gönderilmez. Tüm hizmet çevrim içi sunulur. Bu nedenle:</p>
      <ul>
        <li>Kargo takip numarası oluşturulmaz.</li>
        <li>Teslimat adresi soru olarak yer almaz (fatura adresi hariç).</li>
        <li>Herhangi bir kargo/lojistik ücreti tahsil edilmez.</li>
      </ul>

      <h2>4. Erişim ve Uptime</h2>
      <p>Hizmet 7/24, %99.9 uptime SLA ile sunulur. Planlı bakımlar önceden e-posta ve panel içi bildirim ile duyurulur. Beklenmedik kesintiler için canlı durum sayfası ve destek kanalları aktiftir.</p>

      <h2>5. Sorun ve Destek</h2>
      <p>Aktivasyon veya kullanım sırasında herhangi bir sorunla karşılaşırsanız:</p>
      <ul>
        <li><strong>E-posta:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> — 7 gün / 24 saat</li>
        <li><strong>Telefon:</strong> {COMPANY.phone} — mesai saatleri</li>
        <li><strong>Adres:</strong> {COMPANY.address}</li>
      </ul>

      {/* Icon grid summary */}
      <div className="mt-10 grid sm:grid-cols-4 gap-4 not-prose">
        {[
          { i: Zap, l: "Anında Aktivasyon" },
          { i: Cloud, l: "%100 Bulut Tabanlı" },
          { i: Truck, l: "Kargo Yok", strike: true },
          { i: CheckCircle2, l: "İşlemsel Fatura" },
        ].map((c, k) => (
          <div key={k} className="border border-white/10 p-4 flex flex-col items-start gap-2">
            <c.i size={18} style={{ color: "var(--gold)" }} className={c.strike ? "opacity-40" : ""} />
            <div className={`text-[11px] font-mono tracking-wider ${c.strike ? "line-through text-neutral-500" : "text-neutral-300"}`}>
              {c.l.toUpperCase()}
            </div>
          </div>
        ))}
      </div>
    </LegalLayout>
  );
}
